var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-relative"},[_c('Toolbar',{attrs:{"isList":true,"menu":_vm.fakeMenu},on:{"toolbar-button-click":_vm.onToolbarClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }